/*
SaiKrishna 10/06/2022 3225736869 Removed unnecessary console.log statements
Raghu 27/10/2022 3225736869 Table Alignment Fixes and Enhancements
Ashraf 10/30/2022 3225736869 fixed table pagination issue
Prakash 10/31/2022 3225736869 Made Toolbar false.
saikrishna 11/03/2022 3225736869 changed the paginationOptions
Dilip 11/03/2022  3225736869 added task code to delete popup
Suresh Peddavoora 03/20/2023 3225736869 Added dropdown for icons in action column

*/

import React, {useState} from 'react';
import {MTableBody, MTableBodyRow} from 'material-table';
// import MaterialTable, { MTableBody, MTableBodyRow } from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import {tableIcons} from '../../../../../components/TableIcons';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import {tablePageRows, defaultRows} from '../../../../../constants/ReusableTablePagination';
import DeleteTableRecordPopup from './../../../../../util/DeleteTableRecordPopup';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import SaveIcon from '@material-ui/icons/Save';
import ActionMenuItem from '../../../../../util/ActionMenuItem';

export default function RuleGroupTable({
  nightJobCode,
  formData,
  setFormData,
  deletedRules,
  setDeletedRules,
  setIsEditMode,
  rowData,
  setRowData,
  setOldRuleCode,
}) {
  const useStyles = makeStyles({
    letterTable: {
      '& .MuiTableRow-root': {
        color: 'inherit',
        display: 'inherit',
        outline: 0,
        verticalAlign: 'middle',
      },
      '& .MuiTableBody-root': {
        'display': 'inherit',
        'textAlign': 'center',
        '& .MuiTableCell-root:nth-child(1)': {
          maxWidth: '90px',
        },
      },
      '& .MuiTableSortLabel-root > div': {
        fontSize: '0.790rem !important',
        fontWeight: 'bold !important',
      },
    },
  });
  const columns = [
    {
      title: 'S.No',
      // cellStyle: { maxWidth: 500 },
      // maxWidth: "300px",
      render: (rowData) => rowData.tableData.id ? rowData.tableData.id + 1 : rowData.tableData.id === 0 ? 1 : '',
    },
    {
      title: 'Task Code',
      field: 'taskCode',
      // cellStyle: { maxWidth: 500 },
      // minWidth: "300px",
    },
    {
      title: 'Task Type',
      field: 'taskType',
      // width: "2%",
      // cellStyle: { maxWidth: 500 },
      // minWidth: "300px",
    },

    {
      title: 'Task Parameters',
      field: 'parameters',
      // width: "2%",
      // minWidth: "400px",
      render: (rowData) => (
        <>
          <div
            style={{
              // maxWidth: 300,
              textAlign: 'justify',
              whiteSpace: 'normal',
              wordWrap: 'break-word',
            }}
          >
            {rowData.parameters}
          </div>
        </>
      ),
    },
  ];

  const classes = useStyles();
  const [userData, setUserData] = useState(null);
  const [isDelete, setIsDelete] = useState(false);
  const [rows, setRows] = useState(defaultRows);


  const handleEditRow = (rowData) => {
    setIsEditMode(true);
    setRowData(rowData);
  };
  const handleDelete = (rowData) =>{
    setUserData(rowData);
    setIsDelete(true);
  };
  const handleEdit = (rowData) => {
    handleEditRow(rowData);
    setOldRuleCode(rowData.taskCode);
  };
  const handleCloseDialog = () => {
    setIsDelete(false);
  };
  const handleSubmit = () =>{
    new Promise((resolve) => {
      setTimeout(() => {
        const data = [...formData];
        const newData = data.filter((row) => row.taskCode !== userData.taskCode);
        setFormData(newData);
        userData?.ruleId && deletedRules.length > 0 ?
          setDeletedRules([...deletedRules, userData.ruleId]) :
          setDeletedRules([userData.ruleId]);
        resolve();
        handleCloseDialog();
      }, 1000);
    });
  };
  const onDragEnd = (result) => {
    const {destination, source} = result;
    if (!destination) {
      return;
    }
    if (source.index !== destination.index) {
      const copyRows = [...formData];
      const temp = formData[source.index];
      copyRows.splice(source.index, 1);
      copyRows.splice(destination.index, 0, temp);
      setFormData(copyRows);
    }
  };

  return (
    <>
      <DeleteTableRecordPopup open={isDelete} dialogClose={handleCloseDialog} title="Delete Night Jobs" 
        value={`Are you sure you want to delete this ${userData?.taskCode} Job?`} handleSubmit={handleSubmit}/>
      <Grid item xs={12}>
        <div className={`custom-table global-field-table custom-actions-icon ${classes.letterTable}
          drag-and-drop-table custom-map-sec new-standard-textfields triggerDrag-dropTable`}>
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            data={formData}
            textAlign="left"
            options={{
              search: false,
              toolbar: false,
              pageSize: rows,
              pageSizeOptions: tablePageRows,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
                fontSize: '0.938rem',
                padding: '16px',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
              Action: (props) => (
                <ActionMenuItem
                  {...props}
                  handleDelete={handleDelete}
                  handleEdit={handleEdit}
                  // handleView={handleView}
                  hiddenMenu={{
                    edit: false,
                    // view: false,
                    copy: true,
                    notes: true,
                    hiddenDelete: false,
                    execution: true,
                    run: true,
                    usage: true,
                    user: true,
                    password: true,
                    test: true,
                  }}
                  disableMenu={{
                    disableEdit: false,
                    disableRun: false,
                    // disableView: !nightJobCode,
                    disableCopy: false,
                    disableDelete: false,
                    disableUsage: false,
                    disableExecution: false,
                    disableNotes: false,
                    disableUser: false,
                    disablePassword: false,
                    disableTest: false,
                  }}
                />
              ),
              Body: (props) => (
                <div>
                  <DragDropContext onDragEnd={onDragEnd}>
                    <Droppable droppableId={'singleColumnDroppableAreaThusStaticInput'}>
                      {(provided) => (
                        <div ref={provided.innerRef}>
                          <MTableBody {...props} />
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                </div>
              ),
              Row: (props) => (
                <Draggable
                  draggableId={props.data.tableData.id.toString()}
                  index={props.data.tableData.id}
                >
                  {(provided) => (
                    <div
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      ref={provided.innerRef}
                    >
                      <MTableBodyRow {...props} />
                    </div>
                  )}
                </Draggable>
              ),
            }}
            // editable={{
            //   onRowDelete: (rowData) => {
            //     return new Promise((resolve) => {
            //       setTimeout(() => {
            //         const data = [...formData];
            //         const index = rowData.tableData.id;
            //         data.splice(index, 1);
            //         setFormData([...data]);
            //         rowData?.ruleId && deletedRules.length > 0
            //           ? setDeletedRules([...deletedRules, rowData.ruleId])
            //           : setDeletedRules([rowData.ruleId]);
            //         resolve();
            //       }, 1000);
            //     });
            //   },
            // }}
            // actions={[
            //   {
            //     icon: "edit",
            //     tooltip: "Edit",
            //     onClick: (event, rowData) => {
            //       handleEditRow(rowData);
            //       setOldRuleCode(rowData.taskCode);
            //     },
            //   },
            //   {
            //     icon: "visibility",
            //     tooltip: "View Executions",
            //     disabled: !nightJobCode,
            //   },
            //   {
            //     icon: "delete",
            //     // disabled: !breCode && !disableDelete,
            //     tooltip: "Delete",
            //     onClick: (event,rowData) => handleDelete(rowData),
            //     },
            // ]}
            actions={
              [
                {
                  icon: () => <SaveIcon />,
                  tooltip: 'Save User',
                  onClick: (event, rowData) => console.log(rowData, 'rowData'),
                },
              ]
            }
          />
        </div>
      </Grid>
    </>
  );
}
